import { H1Tag, H1Wrapper } from "./styles";

/** Shown when URL is plain `/jobs` (segment "jobs" is not a keyword) or no title/keyword could be derived. */
const DEFAULT_JOBS_LISTING_H1 =
  "Jobs in Malaysia - Search Job Vacancies - Career | Hiredly";

export default function JobListSubheader(props) {
  const { titleInfo, filterParams } = props;
  const { title, key } = titleInfo ?? {};
  const keyword = Array.isArray(filterParams?.keyword)
    ? filterParams?.keyword?.[0]
    : filterParams?.keyword;

  const headingText =
    titleInfo || title
      ? key === "state"
        ? "Jobs in " + title
        : title + " Jobs"
      : keyword
      ? `${keyword} Jobs`
      : "";

  const resolvedHeading = headingText || DEFAULT_JOBS_LISTING_H1;

  return (
    <H1Wrapper>
      <H1Tag>{resolvedHeading}</H1Tag>
    </H1Wrapper>
  );
}
